import Invitee from '../components/Trial/Invitee'

let routes = {
    path: '/trial',
    component: resolve => require(['../components/layout/Login'], resolve),
    children: [
        {
            path: '/trial-invitee',
            name: 'Trial - Invitee',
            component: Invitee
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/trial.js